/**
 * Sticky Add to Cart - JavaScript
 * Maneja la funcionalidad del botón sticky de añadir al carrito
 */

document.addEventListener('DOMContentLoaded', function() {
  const stickyBar = document.getElementById('sticky-add-to-cart');
  const addToCartBtn = document.getElementById('sticky-add-to-cart-btn');
  const hiddenVariantInput = stickyBar.querySelector('input[name="id"]');

  // Función para ajustar la posición del sticky según el banner/navegación de la app
  function adjustStickyPosition() {
    let totalBottomHeight = 0;

    // Buscar la barra de navegación inferior de la app (con iconos)
    const appNavBar = document.querySelector(
      'nav[style*="position: fixed"][style*="bottom"], ' +
      'div[style*="position: fixed"][style*="bottom"], ' +
      '.webapp-nav, ' +
      '[data-webapp-nav], ' +
      '.app-navigation, ' +
      '[data-app-navigation], ' +
      '.bottom-nav, ' +
      '.bottom-navigation, ' +
      '[class*="bottom-nav"], ' +
      '[class*="navigation"][style*="bottom"]'
    );

    // Buscar el banner de "Abrir en la app"
    const appBanner = document.querySelector(
      '.app-banner, ' +
      '[data-app-banner], ' +
      '#shopify-app-banner, ' +
      '.shopify-app-banner, ' +
      '[id*="app-banner"], ' +
      '[class*="app-banner"]'
    );

    // Sumar la altura de la barra de navegación
    if (appNavBar && appNavBar.offsetHeight > 0 && window.getComputedStyle(appNavBar).display !== 'none') {
      totalBottomHeight += appNavBar.offsetHeight;
    }

    // Sumar la altura del banner (si existe)
    if (appBanner && appBanner.offsetHeight > 0 && window.getComputedStyle(appBanner).display !== 'none') {
      totalBottomHeight += appBanner.offsetHeight;
    }

    // Aplicar la altura total
    if (totalBottomHeight > 0) {
      stickyBar.style.bottom = totalBottomHeight + 'px';
    } else {
      stickyBar.style.bottom = '0px';
    }
  }

  // Ajustar posición inicial con múltiples intentos
  setTimeout(adjustStickyPosition, 100);
  setTimeout(adjustStickyPosition, 500);
  setTimeout(adjustStickyPosition, 1000);
  setTimeout(adjustStickyPosition, 2000);

  // Observar cambios en el DOM para detectar cuando aparece/desaparece el banner
  const positionObserver = new MutationObserver(function() {
    adjustStickyPosition();
  });

  positionObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  // También ajustar en resize
  window.addEventListener('resize', adjustStickyPosition);

  // Verificar periódicamente (por si el banner aparece dinámicamente)
  setInterval(adjustStickyPosition, 3000);

  // Mostrar/ocultar el sticky bar al hacer scroll
  const productForm = document.querySelector('form[action*="/cart/add"]');
  const isMobile = window.innerWidth <= 768;

  // En móviles, mostrar siempre el sticky
  if (isMobile) {
    stickyBar.classList.add('visible');
  } else if (productForm) {
    // En desktop, mostrar solo al hacer scroll
    const formPosition = productForm.getBoundingClientRect().top + window.pageYOffset;

    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;

      // Mostrar el sticky cuando el formulario original no está visible
      if (currentScroll > formPosition + 200) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    });
  }

  // Detectar cambios de tamaño de ventana
  window.addEventListener('resize', function() {
    const isMobileNow = window.innerWidth <= 768;
    if (isMobileNow) {
      stickyBar.classList.add('visible');
    }
  });

  // Selector de tallas del sticky - SIMPLIFICADO
  const stickySizeOptions = document.querySelectorAll('.sticky-size-option');

  // Selector de tallas del sticky
  stickySizeOptions.forEach(option => {
    option.addEventListener('click', function() {
      if (!this.classList.contains('disabled')) {
        stickySizeOptions.forEach(opt => opt.classList.remove('selected'));
        this.classList.add('selected');
      }
    });
  });

  // Funcion para actualizar el contador del carrito
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = cart.item_count;

        // Actualizar todos los elementos con clase 'cart-count'
        const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
        cartCountElements.forEach(element => {
          element.textContent = cartCount;
          if (cartCount > 0) {
            element.style.display = 'block';
          }
        });
      })
      .catch(error => console.error('Error updating cart count:', error));
  }

  // Funcion para refrescar el contenido del carrito drawer
  function refreshCartDrawer() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Disparar eventos de actualización del carrito
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

        // Buscar el drawer y refrescarlo
        const cartDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer-container]');
        if (cartDrawer) {
          // Si tiene método refresh/update, llamarlo
          if (typeof cartDrawer.refresh === 'function') {
            cartDrawer.refresh();
          } else if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(cart);
          } else if (typeof cartDrawer.getSectionsToRender === 'function') {
            // Shopify 2.0 method
            cartDrawer.getSectionsToRender().forEach((section) => {
              fetch(`${window.location.pathname}?section_id=${section.section}`)
                .then(response => response.text())
                .then(html => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  const newContent = doc.querySelector(section.selector);
                  if (newContent) {
                    document.querySelector(section.selector).innerHTML = newContent.innerHTML;
                  }
                });
            });
          } else {
            // Método alternativo: Recargar la sección del carrito
            fetch('/?section_id=cart-drawer')
              .then(response => response.text())
              .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newDrawerContent = doc.querySelector('.drawer__inner, .cart-drawer__inner, [data-cart-items]');
                const currentDrawerContent = cartDrawer.querySelector('.drawer__inner, .cart-drawer__inner, [data-cart-items]');

                if (newDrawerContent && currentDrawerContent) {
                  currentDrawerContent.innerHTML = newDrawerContent.innerHTML;
                }
              })
              .catch(error => console.error('Error reloading cart section:', error));
          }
        }

        return cart;
      })
      .catch(error => console.error('Error refreshing cart:', error));
  }

  // Funcion para abrir el carrito drawer
  function openCartDrawer() {
    // Primero refrescar el contenido del carrito
    refreshCartDrawer().then(() => {
      // Metodo 1: Buscar y hacer click en el boton del carrito
      const cartButton = document.querySelector('[data-cart-drawer], [data-open-cart], .js-drawer-open-cart, #cart-icon-bubble, .header__icon--cart');
      if (cartButton) {
        cartButton.click();
        return;
      }

      // Metodo 2: Buscar el drawer y abrirlo directamente
      const cartDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer-container]');
      if (cartDrawer) {
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.classList.add('is-open', 'active', 'is-opened');
          cartDrawer.setAttribute('is-opened', 'true');
        }
        return;
      }

      // Metodo 3: Llamar a funciones globales comunes
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      } else if (typeof window.Shopify !== 'undefined' && typeof window.Shopify.openCartDrawer === 'function') {
        window.Shopify.openCartDrawer();
      } else if (typeof theme !== 'undefined' && typeof theme.openCart === 'function') {
        theme.openCart();
      }
    });
  }

  // Añadir al carrito
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function() {
      const button = this;
      const originalText = button.querySelector('span').textContent;

      // Obtener la talla seleccionada
      const selectedSizeElement = document.querySelector('.sticky-size-option.selected');

      if (!selectedSizeElement) {
        alert('Por favor, selecciona una talla');
        return;
      }

      // Obtener el ID de la variante
      let variantId = selectedSizeElement.getAttribute('data-variant-id');

      if (!variantId && hiddenVariantInput) {
        variantId = hiddenVariantInput.value;
      }

      // Actualizar el formulario original del producto con la variante seleccionada
      const productForm = document.querySelector('form[action*="/cart/add"]');
      if (productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
        }

        // Buscar el botón de añadir al carrito original
        const originalAddToCartBtn = productForm.querySelector('button[type="submit"][name="add"]');

        if (originalAddToCartBtn) {
          // Marcar que estamos añadiendo al carrito
          if (window.stickyCartIsAdding) {
            window.stickyCartIsAdding(true);
          }

          // Deshabilitar botón sticky durante la petición
          button.disabled = true;
          button.querySelector('span').textContent = 'Añadiendo...';

          // Simular click en el botón original (esto usará toda la lógica del tema)
          originalAddToCartBtn.click();

          // Esperar un poco y restaurar el botón sticky
          setTimeout(() => {
            button.querySelector('span').textContent = '¡Añadido!';
            button.style.background = '#28a745';

            setTimeout(() => {
              button.disabled = false;
              button.querySelector('span').textContent = originalText;
              button.style.background = '';

              // Marcar que terminamos de añadir al carrito
              if (window.stickyCartIsAdding) {
                window.stickyCartIsAdding(false);
              }
            }, 2000);
          }, 500);

          return;
        }
      }

      // Fallback: Si no se encuentra el formulario original, usar AJAX directo
      const quantity = 1;
      button.disabled = true;
      button.querySelector('span').textContent = 'Añadiendo...';

      const cartDrawer = document.querySelector('#CartDrawer');
      const sectionId = cartDrawer ? cartDrawer.getAttribute('data-section-id') : 'cart-drawer';

      const formData = new FormData();
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', quantity);
      formData.append('sections', sectionId);
      formData.append('sections_url', window.location.pathname);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(response => response.json())
      .then((data) => {
        button.querySelector('span').textContent = '¡Añadido!';
        button.style.background = '#28a745';

        if (data.sections && data.sections[sectionId]) {
          const cartDrawerElement = document.querySelector('#CartDrawer');
          if (cartDrawerElement) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data.sections[sectionId], 'text/html');
            const newCartContent = doc.querySelector('#CartDrawer');

            if (newCartContent) {
              cartDrawerElement.innerHTML = newCartContent.innerHTML;
            }
          }
        }

        updateCartCount();

        setTimeout(() => {
          const sidebarButton = document.querySelector('[data-sidebar-button][data-sidebar-id="CartDrawer"]');
          if (sidebarButton) {
            sidebarButton.click();
          }
        }, 200);

        setTimeout(() => {
          button.disabled = false;
          button.querySelector('span').textContent = originalText;
          button.style.background = '';
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        button.querySelector('span').textContent = 'Error';
        button.style.background = '#dc3545';

        setTimeout(() => {
          button.disabled = false;
          button.querySelector('span').textContent = originalText;
          button.style.background = '';
        }, 2000);
      });
    });
  }

  // Ocultar sticky cuando el modal del carrito se abre
  let isAddingToCart = false; // Flag para saber si estamos añadiendo al carrito

  function hideSticky() {
    if (stickyBar && !isAddingToCart) {
      stickyBar.style.visibility = 'hidden';
      stickyBar.style.opacity = '0';
      stickyBar.style.pointerEvents = 'none';
    }
  }

  function showSticky() {
    if (stickyBar && !isAddingToCart) {
      stickyBar.style.visibility = '';
      stickyBar.style.opacity = '';
      stickyBar.style.pointerEvents = '';
    }
  }

  // Observar cambios en el body para detectar cuando se abre el carrito
  const bodyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class' && !isAddingToCart) {
        const body = document.body;
        // Solo ocultar si tiene sidebar-open o cart-open (no overflow-hidden solo)
        if (body.classList.contains('sidebar-open') ||
            body.classList.contains('cart-open')) {
          hideSticky();
        } else if (!body.classList.contains('sidebar-open') &&
                   !body.classList.contains('cart-open')) {
          showSticky();
        }
      }
    });
  });

  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  // Observar el cart drawer directamente
  const cartDrawerElement = document.querySelector('cart-drawer, #CartDrawer');
  if (cartDrawerElement) {
    const drawerObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (!isAddingToCart && (mutation.attributeName === 'open' ||
            mutation.attributeName === 'is-opened' ||
            mutation.attributeName === 'class')) {
          const isOpen = cartDrawerElement.hasAttribute('open') ||
                        cartDrawerElement.hasAttribute('is-opened') ||
                        cartDrawerElement.classList.contains('is-open') ||
                        cartDrawerElement.classList.contains('is-opened');

          if (isOpen) {
            hideSticky();
          } else {
            showSticky();
          }
        }
      });
    });

    drawerObserver.observe(cartDrawerElement, {
      attributes: true,
      attributeFilter: ['open', 'is-opened', 'class']
    });
  }

  // Escuchar eventos personalizados del carrito (solo si no estamos añadiendo)
  document.addEventListener('cart:open', function() {
    if (!isAddingToCart) hideSticky();
  });
  document.addEventListener('cart:opened', function() {
    if (!isAddingToCart) hideSticky();
  });
  document.addEventListener('cart-drawer:open', function() {
    if (!isAddingToCart) hideSticky();
  });
  document.addEventListener('sidebar:open', function() {
    if (!isAddingToCart) hideSticky();
  });

  document.addEventListener('cart:close', showSticky);
  document.addEventListener('cart:closed', showSticky);
  document.addEventListener('cart-drawer:close', showSticky);
  document.addEventListener('sidebar:close', showSticky);

  // Exponer la variable para que el botón pueda usarla
  window.stickyCartIsAdding = function(adding) {
    isAddingToCart = adding;
  };

});